import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'
import MySpiner from '../../../../UI/spiner/MySpiner'
import SuccessMessage from '../../../../UI/messages/SuccessMessage'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { editSupplyBillsListByBills, setSupplyBillsChecked } from '../../../../../store/supplyBillSlice'
import { agreeHeaderSupplyBillsCheckedAPI } from '../../../../../api/supply/supplyBillAPI'

const AgreeLeaderForm = () => {

    const checked = useSelector(state => state.supplyBill.supplyBills.checked)
    const dispatch = useDispatch()

    const [data, setData] = useState({}) // Дані з форми

    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми

    const [count, setCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    useEffect(() => {
        changeCountBills()
    }, [checked])

    const changeCountBills = () => {
        let temp = 0

        for (const check in checked) {
            if (checked[check]) {
                temp += 1
            }
        }

        setCount(temp)
    }

    const send = () => {
        setLoading(true)
        setSuccess('')
        setError('')

        agreeHeaderSupplyBillsCheckedAPI({ 
            checked,
            isAgreeLeadership: data.isAgreeLeadership, 
            disagreeLeadershipText: data.disagreeLeadershipText
        }).then(data => {
            if (data) {
                dispatch(editSupplyBillsListByBills(data))
                dispatch(setSupplyBillsChecked({}))
            }
            setSuccess('Успішно проставлено погодження в усіх рахунках')
            setLoading(false)
        }).catch (e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження всіх позицій в рахунках <b>керівником</b>
            </p>
            <p>
                Важливо! Погодження буде лише тих позицій, які ще не мають жодного погодження. <br />В іншому випадку треба погоджувати окремо
            </p>
            <p>
                Обрано рахунків: <b>{ count } шт.</b>
            </p>
        </div>

        {
			formDataProductIsField('agree', 'supplyBillItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplyBillItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeLeadership', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeLeadership', e)}
					forciblyValue={
                        data && data.isAgreeLeadership === true ? true :
                        data && data.isAgreeLeadership === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyBillItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeLeadership === false || data.isAgreeLeadership === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyBillItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeLeadershipText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeLeadershipText', e)}
					forciblyValue={data ? data.disagreeLeadershipText : ''}
                    className={data && (data.isAgreeLeadership === false || data.isAgreeLeadership === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        {
            loading ? <MySpiner /> : ''
        }
       
        <SuccessMessage
            success={success}
        />
        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={send}
            disabled={!isValidForm || loading ? true : false}
            // disabled={loading ? true : false}
        >
            Надіслати
        </MyButton>
    </div>
  )
}

export default AgreeLeaderForm